var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.80475 0.201362C6.06508 0.469852 6.06508 0.90515 5.80475 1.17364L1.60948 5.50001L5.80475 9.82638C6.06508 10.0949 6.06508 10.5302 5.80475 10.7986C5.54441 11.0671 5.12228 11.0671 4.86195 10.7986L0.195261 5.98614C0.0702402 5.85723 0 5.68233 0 5.50001C0 5.31768 0.0702402 5.14278 0.195261 5.01388L4.86195 0.201362C5.12228 -0.0671207 5.54441 -0.0671207 5.80475 0.201362Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.3f7ffbd5707c0ebbbe56bc17f68b063e.svg";
export { ForwardRef as ReactComponent };